import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormField, FormItem, FormLabel, FormDescription } from '@/components/ui/form'
import type { ObjectFormData } from '../schema'

interface RecoveryDocumentVideoTabProps {
    form: UseFormReturn<ObjectFormData>
}

export function RecoveryDocumentVideoTab({ form }: RecoveryDocumentVideoTabProps) {
    const { t } = useTranslation()

    return (
        <div className="space-y-6">
            <FormField
                control={form.control}
                name="RecoveryDocument"
                render={() => (
                    <FormItem>
                        <FormLabel>{t('objects.recoveryDocument')}</FormLabel>
                        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                            <p className="text-muted-foreground">
                                {t('objects.recoveryDocumentPlaceholder')}
                            </p>
                            <FormDescription className="mt-2">
                                {t('objects.recoveryDocumentDescription')}
                            </FormDescription>
                        </div>
                    </FormItem>
                )}
            />

            <FormField
                control={form.control}
                name="RecoveryVideo"
                render={() => (
                    <FormItem>
                        <FormLabel>{t('objects.recoveryVideo')}</FormLabel>
                        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg p-8 text-center">
                            <p className="text-muted-foreground">
                                {t('objects.recoveryVideoPlaceholder')}
                            </p>
                            <FormDescription className="mt-2">
                                {t('objects.recoveryVideoDescription')}
                            </FormDescription>
                        </div>
                    </FormItem>
                )}
            />
        </div>
    )
}
